import { DefaultButton, Stack, TooltipHost } from '@fluentui/react';
import React from 'react';
import { Case } from 'services';

function copyTextToClipboard(reference): void {
  // Create a dummy input to copy the string array inside it
  reference.current.select();
  document.execCommand('copy');
}

interface LocationActionBarProps {
  case: Case;
}

export const LocationActionBar: React.FunctionComponent<LocationActionBarProps> = props => {
  const latitudeRef = React.createRef<HTMLInputElement>();
  const longitudeRef = React.createRef<HTMLInputElement>();

  const [lat, long] = props.case.subject.subjectId.split(',');
  return (
    <Stack horizontal>
      <Stack.Item>
        <input type="text" readOnly value={lat} ref={latitudeRef} style={{ opacity: 0, width: '5px' }} />
      </Stack.Item>
      <Stack.Item>
        <input type="text" readOnly value={long} ref={longitudeRef} style={{ opacity: 0, width: '5px' }} />
      </Stack.Item>
      <Stack.Item>
        <TooltipHost content={lat}>
          <DefaultButton
            iconProps={{ iconName: 'Copy' }}
            text="Copy Lat"
            className="m-1"
            onClick={(): void => copyTextToClipboard(latitudeRef)}
          />
        </TooltipHost>
      </Stack.Item>
      <Stack.Item>
        <TooltipHost content={long}>
          <DefaultButton
            iconProps={{ iconName: 'Copy' }}
            text="Copy Long"
            className="m-1"
            onClick={(): void => copyTextToClipboard(longitudeRef)}
          />
        </TooltipHost>
      </Stack.Item>
    </Stack>
  );
};
